interface Props {
  imagePath: string;
  disableDownload?: boolean;
}

export function AlarmImage(props: Props) {
  const { imagePath, disableDownload } = props;

  return (
    <img
      src={imagePath}
      alt="Alarm media"
      onContextMenu={disableDownload ? (e) => e.preventDefault() : undefined}
      draggable={disableDownload ? false : undefined}
      className="dark:bg-dark-bg/70 max-h-[48rem] w-full bg-gray-200"
    />
  );
}

export default AlarmImage;
